module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yyn-2cf0089b2385eedc9dea34b9d82d8d06.png";